module.exports = __webpack_public_path__ + "img/terrestre.84fdd104.png";